export default __webpack_public_path__ + "static/media/incubator.ae4e1cb8.jpg";